<template>
  <v-app-bar
    color="#F1F2F6"
    
    height="120"
    width="1264px"
    min-height="120"
    style="border-top-left-radius: 8px !important; border-top-right-radius: 8px !important;"
  >

    <v-img
    id="top"
      :src="logo_head"
      class="logo mt-1"
      max-height="120"
      max-width="283"
      @click="goToPage('main')"
      style="cursor: pointer;"
      ></v-img>

    <v-spacer></v-spacer>

      <!-- <v-btn value="about" height="40" >
        About
      </v-btn>

      <v-btn value="leadership"  height="40" class="text_color">
        Leadership
      </v-btn>

      <v-btn value="members" height="40" class="text_color">
        Members
      </v-btn> -->
      <div class="d-none d-md-flex">
        <div class="d-none d-lg-flex">
          <v-btn
            outlined
            rounded
            height="40"
            class="text_color no-uppercase mr-4"
            @click="goToPage('main')"
            style="font-size: 22px; border-radius: 48px; border-width: 3px; font-weight: 400;"
          >
          {{ $t('main') }}
          </v-btn>
        </div>
        <v-btn
          outlined
          rounded
          height="40"
          class="text_color no-uppercase mr-4"
          @click="goToPage('about')"
          style="font-size: 22px; border-radius: 48px; border-width: 3px; font-weight: 400;"
        >
        {{ $t('cys_iaas_small') }}
        </v-btn>
        <v-btn
          outlined
          rounded
          height="40" class="text_color no-uppercase"
          @click="goToPage('members')"
          style="font-size: 22px; border-radius: 48px; border-width: 3px;font-weight: 400;"
        >

        {{ $t('members') }}
        </v-btn>
      </div>


      <div class="d-md-none">
        <v-menu
          bottom
          left
        >
          <template v-slot:activator="{ on }">
            <v-btn
            
              outlined
              rounded
              color="black"
              style="border-radius: 48px; border-width: 3px;"
              icon
              v-on="on">
              <v-icon x-large>mdi-dots-vertical</v-icon>
            </v-btn>
          </template>
          <v-list     color="#adadad">
            <v-list-item
              class="item-menu-text"
              small
              v-for="(item, i) in $t('menu_list')"
              :key="i"
              @click="goToPage(item.slug)">
              <v-list-item-action>
                <v-icon :color="$mainColor" >{{ item.icon }}</v-icon>
              </v-list-item-action>
              <v-list-item-title>{{ item.title }}</v-list-item-title>
            </v-list-item>
          </v-list>
        </v-menu>

      </div>

<!-- lang -->
    <!-- <v-menu style="border-radius: 48px; border-width: 3px;">
      <template v-slot:activator="{ on }">
        <v-btn
          class="text_color ml-4 mr-2"
          outlined
          rounded
          color="black"
          style="font-size: 22px; border-radius: 48px; border-width: 3px;font-weight: 400;"
          icon
          v-on="on">
          <v-icon>mdi-translate</v-icon>
        </v-btn>
      </template>
      <v-list>
        <v-list-item
          class="item-menu-text"
          x-small
          v-if="lang!='ru'"
          @click="setLang('ru')">
          <v-list-item-action>
            <v-img
              :src="ru_flag"
              class="logo"
            ></v-img>
          </v-list-item-action>
          <v-list-item-title>RUS</v-list-item-title>
        </v-list-item>
        <v-list-item
          class="item-menu-text"
          x-small
          v-if="lang!='ch'"
          @click="setLang('ch')">
          <v-list-item-action>
            <v-img
              :src="ch_flag"
              class="logo"
            ></v-img>
          </v-list-item-action>
          <v-list-item-title>CH</v-list-item-title>
        </v-list-item>
        <v-list-item
          class="item-menu-text"
          x-small
          v-if="lang!='en'"
          @click="setLang('en')">
          <v-list-item-action>
            <v-img
              :src="en_flag"
              class="logo"
            ></v-img>
          </v-list-item-action>
          <v-list-item-title>EN</v-list-item-title>
        </v-list-item>
      </v-list>
    </v-menu> -->



  </v-app-bar>
</template>

<script>
import logo from '../../assets/ustoc.png';
import iaas_logo from '../../assets/IAAS_back_logo.png';
import logo_head from '../../assets/logo-head.svg';
import en_flag from '../../assets/flags/en.png';
import ch_flag from '../../assets/flags/ch.png';
import ru_flag from '../../assets/flags/rus_64.png';
import { mapActions, mapMutations, mapGetters } from 'vuex';

export default {
  name: 'HeaderForPage',
  components: {
  },

  data() {
    return {
      logo,
      iaas_logo,
      logo_head,
      en_flag,
      ch_flag,
      ru_flag,
      lang: 'ru',
      loading: true,
      changeLanguage: 'ru',
    }
  },

  mounted() {
  },

  watch:{

    changeLanguage(newLang) {
/*
        if (newLang) {
          localStorage.token ? (this.LANGUAGE_SWITCH({
            id: this.GETTERS_LOGIN,
            language: 'en'
          }) , this.$i18n.locale = 'en') : (this.SET_APP_LANGUAGE('en'), this.$i18n.locale = 'en')

        }
        else {
          localStorage.token ? (this.LANGUAGE_SWITCH({
            id: this.GETTERS_LOGIN,
            language: 'ru'
          }), this.$i18n.locale = 'ru') : (this.SET_APP_LANGUAGE('ru'), this.$i18n.locale = 'ru')
        }
      */
    }
  },
  beforeMount() {
    this.setLang('ru')
  },

  methods: {
    ...mapActions(['LANGUAGE_SWITCH']),
    ...mapMutations([
      'SET_APP_LANGUAGE', 
      'UPDATE_OVERLAY',
    ]),
    
    setLang(new_lang){
      // console.log('setLang: ', new_lang)
      this.lang = new_lang
      this.SET_APP_LANGUAGE(new_lang)
      this.$i18n.locale = new_lang
    },


    async goToPage(item) {
      switch (item) {
        case 'logout':
          this.SET_IS_LOGGED_IN('');
          this.LOGOUT()
          break;
        case 'personal-data':
          this.$router.push('/personal-data');
          break;
        case 'main':
          this.$router.push('/');
          break;
        case 'privacy':
          this.$router.push('/privacy');
          break;

        case 'about':
          this.$router.push('/about');
          break;
        case 'members':
          this.$router.push('/members');
          break;
        case 'leadership':
          this.$router.push('/leadership');
          break;
        case 'news':
          this.$router.push('/news');
          break;
        default:
          break;
      }
    },
  },
};
</script>
